/**
 * REUSABLE COMPONENT - Select
 * Generic select/dropdown component
 * Can be used in any React project
 */

import React, { forwardRef } from 'react';

const Select = forwardRef(
  (
    {
      label,
      options = [],
      value,
      onChange,
      error,
      disabled = false,
      required = false,
      fullWidth = true,
      placeholder = 'Sélectionnez une option',
      helperText,
      className = '',
      selectClassName = '',
      ...props
    },
    ref
  ) => {
    const containerClasses = fullWidth ? 'w-full' : '';

    const selectBaseClasses = 'block px-4 py-2 text-gray-900 border rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 disabled:bg-gray-100 disabled:cursor-not-allowed';

    const selectStateClasses = error
      ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
      : 'border-gray-300 focus:border-blue-500 focus:ring-blue-500';

    const selectWidthClass = fullWidth ? 'w-full' : '';

    const selectClasses = `${selectBaseClasses} ${selectStateClasses} ${selectWidthClass} ${selectClassName}`;

    return (
      <div className={`${containerClasses} ${className}`}>
        {label && (
          <label className="block mb-2 text-sm font-medium text-gray-700">
            {label}
            {required && <span className="text-red-500 ml-1">*</span>}
          </label>
        )}

        <select
          ref={ref}
          value={value}
          onChange={onChange}
          disabled={disabled}
          required={required}
          className={selectClasses}
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((option, index) => (
            <option key={option.value || index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        {error && (
          <p className="mt-1 text-sm text-red-600">{error}</p>
        )}

        {!error && helperText && (
          <p className="mt-1 text-sm text-gray-500">{helperText}</p>
        )}
      </div>
    );
  }
);

Select.displayName = 'Select';

export default Select;
